import ArrowUploadSetup from '@/components/icons/ArrowUploadSetup'
import useIsMountedRef from '@/hooks/useIsMountedRef'
import { Box, BoxProps, Stack, Typography } from '@mui/material'
import clsx from 'clsx'
import { memo, useCallback } from 'react'
import { Accept, useDropzone } from 'react-dropzone'
import classes from './styles.module.scss'

// 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
// 'application/vnd.ms-excel',
// 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
// 'application/msword',
// 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
// 'application/vnd.ms-powerpoint',
// 'application/pdf'

interface Props {
  multiple?: boolean
  disabled?: boolean
  className?: string
  title?: string
  formats?: string[]
  accept?: Accept
  onChange: (file: File[]) => void
  BoxProps?: BoxProps
  filePath?: any
}

const SelectExcelFile = memo(
  ({
    title,
    multiple,
    disabled,
    className,
    onChange,
    BoxProps = {},
    accept,
    formats,
    filePath,
  }: Props) => {
    const isMountedRef = useIsMountedRef()

    const handleDrop = useCallback(
      async (acceptedFiles: File[]) => {
        let hasError = false
        for (const file of acceptedFiles) {
          if (formats?.length && !formats.includes(file.type)) {
            hasError = true
            break
          }
        }
        if (hasError || !acceptedFiles?.length) return
        onChange(acceptedFiles)
      },
      // eslint-disable-next-line
      [isMountedRef, onChange],
    )

    const { getRootProps, getInputProps } = useDropzone({
      accept,
      onDrop: handleDrop,
      multiple: multiple,
      disabled: disabled,
    })

    return (
      <Box
        className={clsx(classes.root, className, {
          [classes.disabled]: disabled,
        })}
        {...BoxProps}
        {...getRootProps()}
      >
        <input {...getInputProps()} />
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          justifyContent="space-between"
          height="44px"
        >
          <Typography className={classes.title}>
            {filePath || 'Select excel file'}
          </Typography>
          {!filePath && <ArrowUploadSetup sx={{ mt: '-5px' }} />}
        </Stack>
      </Box>
    )
  },
)

export default SelectExcelFile
